export function notNullOrUndefined(value?: any): boolean {
  return value !== null && value !== undefined
}
